import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { DateString, IanaTimezone } from '#/types/TypedDateString';

/**
 * @example
 *
 * Given America/New_York
 *
 * //=> EN (d/M/yyyy)
 * EST
 *
 * //=> ES, PT (M/d/yyyy)
 * 7/4/2026
 */
export function shortIanaTimezone(
  timezone: IanaTimezone,
  { date, locale }: { date: DateString; locale: I18nLocale },
) {
  const [year, month, day] = date.split('-').map(Number);

  return (
    new Intl.DateTimeFormat(locale, {
      timeZone: timezone,
      timeZoneName: 'short',
    })
      .formatToParts(new Date(year, month - 1, day))
      .find((p) => p.type === 'timeZoneName')?.value || ''
  );
}
